/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UtxTransferListSendTenorParams,
  TransferP2pResponse,
  TransferP2pRequest,
  TransferSelfResponse,
  TransferSelfRequest,
  Transfer,
  SendRequest,
  TransferPayeeResponse,
  UtxTransferGetPayeeSendableParams
} from './schema'



/**
 * Retrieves a list of available tenor options for a given transfer, query params not used at the moment, will be implemented in the future.
 */
export const utxTransferListSendTenor = (
    params?: UtxTransferListSendTenorParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/transfers/send/tenor`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransferListSendTenorQueryKey = (params?: UtxTransferListSendTenorParams,) => [`/transfers/send/tenor`, ...(params ? [params]: [])];

    
export type UtxTransferListSendTenorQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransferListSendTenor>>>
export type UtxTransferListSendTenorQueryError = AxiosError<unknown>

export const useUtxTransferListSendTenor = <TData = Awaited<ReturnType<typeof utxTransferListSendTenor>>, TError = AxiosError<unknown>>(
 params?: UtxTransferListSendTenorParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransferListSendTenor>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransferListSendTenorQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransferListSendTenor>>> = ({ signal }) => utxTransferListSendTenor(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransferListSendTenor>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxTransferP2p = (
    transferP2pRequest: TransferP2pRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TransferP2pResponse>> => {
    return axios.post(
      `/transfers/p2p`,
      transferP2pRequest,options
    );
  }



    export type UtxTransferP2pMutationResult = NonNullable<Awaited<ReturnType<typeof utxTransferP2p>>>
    export type UtxTransferP2pMutationBody = TransferP2pRequest
    export type UtxTransferP2pMutationError = AxiosError<unknown>

    export const useUtxTransferP2p = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxTransferP2p>>, TError,{data: TransferP2pRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxTransferP2p>>, {data: TransferP2pRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxTransferP2p(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxTransferP2p>>, TError, {data: TransferP2pRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxTransferSelf = (
    transferSelfRequest: TransferSelfRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TransferSelfResponse>> => {
    return axios.post(
      `/transfers/self`,
      transferSelfRequest,options
    );
  }



    export type UtxTransferSelfMutationResult = NonNullable<Awaited<ReturnType<typeof utxTransferSelf>>>
    export type UtxTransferSelfMutationBody = TransferSelfRequest
    export type UtxTransferSelfMutationError = AxiosError<unknown>

    export const useUtxTransferSelf = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxTransferSelf>>, TError,{data: TransferSelfRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxTransferSelf>>, {data: TransferSelfRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxTransferSelf(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxTransferSelf>>, TError, {data: TransferSelfRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxTransferSend = (
    sendRequest: SendRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Transfer>> => {
    return axios.post(
      `/transfers/send`,
      sendRequest,options
    );
  }



    export type UtxTransferSendMutationResult = NonNullable<Awaited<ReturnType<typeof utxTransferSend>>>
    export type UtxTransferSendMutationBody = SendRequest
    export type UtxTransferSendMutationError = AxiosError<unknown>

    export const useUtxTransferSend = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxTransferSend>>, TError,{data: SendRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxTransferSend>>, {data: SendRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxTransferSend(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxTransferSend>>, TError, {data: SendRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxTransferGetPayeeSendable = (
    params: UtxTransferGetPayeeSendableParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TransferPayeeResponse>> => {
    return axios.get(
      `/transfers/sendable`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxTransferGetPayeeSendableQueryKey = (params: UtxTransferGetPayeeSendableParams,) => [`/transfers/sendable`, ...(params ? [params]: [])];

    
export type UtxTransferGetPayeeSendableQueryResult = NonNullable<Awaited<ReturnType<typeof utxTransferGetPayeeSendable>>>
export type UtxTransferGetPayeeSendableQueryError = AxiosError<unknown>

export const useUtxTransferGetPayeeSendable = <TData = Awaited<ReturnType<typeof utxTransferGetPayeeSendable>>, TError = AxiosError<unknown>>(
 params: UtxTransferGetPayeeSendableParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxTransferGetPayeeSendable>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxTransferGetPayeeSendableQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxTransferGetPayeeSendable>>> = ({ signal }) => utxTransferGetPayeeSendable(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxTransferGetPayeeSendable>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

